;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { AppCenteredStatus } from '@workspace/ui/components/custom/app-centered-status';
import { Button } from '@workspace/ui/components/button';
import { CircleAlert } from 'lucide-react';

interface GeneralErrorPageProps {
  error: Error & { digest?: string };
  onTryAgain: () => void;
  onGoBack?: () => void;
  goBackLabel?: string;
  showStackTrace: boolean;
  /** Full-viewport grey canvas for root / global error boundaries that sit outside the app layout. */
  fillViewport?: boolean;
}

function getErrorDetails(error: Error & { digest?: string }): string {
  const parts = [error.message];

  if (error.digest) parts.push(`Digest: ${error.digest}`);
  if (error.stack) parts.push(error.stack);

  return parts.filter(Boolean).join('\n\n');
}

export function GeneralErrorPage({
  error,
  onTryAgain,
  onGoBack,
  goBackLabel = 'Go back',
  showStackTrace,
  fillViewport = false,
}: GeneralErrorPageProps) {
  return (
    <AppCenteredStatus
      fillViewport={fillViewport}
      icon={
        <CircleAlert
          aria-hidden="true"
          className="size-18 stroke-2! text-red-500 dark:text-red-400"
        />
      }
      title="Something went wrong"
      description="We couldn't complete your request. Please try again. If the problem continues, contact our support team."
      actions={
        <div className="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-center sm:gap-4">
          {onGoBack ? (
            <Button
              type="button"
              className="w-full min-w-0 shrink sm:flex-1"
              variant="secondary"
              onClick={onGoBack}
            >
              <p>{goBackLabel}</p>
            </Button>
          ) : null}
          <Button
            type="button"
            className="w-full min-w-0 shrink sm:flex-1"
            variant="primary"
            onClick={onTryAgain}
          >
            <p>Try again</p>
          </Button>
        </div>
      }
    >
      {showStackTrace ? (
        <pre className="bg-grey-25 text-neutral-200 dark:bg-grey-1000 dark:text-neutral-100 mt-8 max-h-[320px] w-full max-w-[720px] overflow-auto rounded-[28px] p-6 text-left font-mono text-xs leading-5 whitespace-pre-wrap">
          {getErrorDetails(error)}
        </pre>
      ) : null}
    </AppCenteredStatus>
  );
}
